// Packages
import React, { useCallback } from "react";
import {
  Card,
  CardBody,
  CardSubtitle,
  CardText,
  CardTitle,
  Container,
  Row,
  Col,
  Button,
} from "reactstrap";
import { BsPatchExclamationFill } from "react-icons/bs";
import { useHistory } from "react-router-dom";
// Styling
import "./PaymentFailed.css";

const PaymentFailed = React.memo((props) => {
  const history = useHistory();

  const onHomeClick = useCallback(() => {
    history.push("/");
  }, [history]);

  return (
    <Container className="mt-5 mb-5 text-center">
      <Row className="mt-5">
        <Col md={4}></Col>
        <Col md={4}>
          <Card
            style={{
              width: "32rem",
            }}
          >
            <CardBody>
              <CardTitle tag="h1">Plata esuata</CardTitle>
              <CardSubtitle className="mb-2 text-muted" tag="h6">
                Plata nu a putut fi procesata
              </CardSubtitle>
            </CardBody>
            <BsPatchExclamationFill className="payment-failed-icon" />
            <CardBody>
              <CardText>
                Va rugam incercati din nou mai tarziu.
              </CardText>
              <Button onClick={onHomeClick}>Home</Button>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
});

export default PaymentFailed;
